import gql from 'graphql-tag'

export const getDashboards = gql`
  query {
    getDashboardItems {
      policiesToday {
        id
        policyName
        policyNumber
        status
        carrier {
          name
        }
        premium
        effectiveDate
        expirationDate
        account {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        writingAgents {
          id
          username
        }
      }
      policiesYesterday {
        id
        policyName
        policyNumber
        status
        account {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        premium
        effectiveDate
        expirationDate
        writingAgents {
          id
          username
        }
      }
      policiesToExpire {
        id
        policyName
        policyNumber
        status
        account {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        premium
        effectiveDate
        expirationDate
        writingAgents {
          id
          username
        }
      }
      accountsToday {
        id
        name
        phone
        producers {
          username
        }
      }
      accountsYesterday {
        id
        name
        phone
        producers {
          username
        }
      }
      casesToHandle {
        id
        inquiryName
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        createdAt
        caseManager {
          username
        }
        type
      }
      casesNewBusiness {
        id
        inquiryName
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        createdAt
        caseManager {
          username
        }
        type
      }
      casesRenewal {
        id
        inquiryName
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        createdAt
        caseManager {
          username
        }
        type
      }
      casesRewrite {
        id
        inquiryName
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        createdAt
        caseManager {
          username
        }
        type
      }
      casesRemarket {
        id
        inquiryName
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        createdAt
        caseManager {
          username
        }
        type
      }
      casesCancellation {
        id
        inquiryName
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        createdAt
        caseManager {
          username
        }
        type
      }
      casesEndorsement {
        id
        inquiryName
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        createdAt
        caseManager {
          username
        }
        type
      }
      casesBOR {
        id
        inquiryName
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        createdAt
        caseManager {
          username
        }
        type
      }
      casesCOI {
        id
        inquiryName
        account {
          id
          name
        }
        primaryContact {
          id
          name
        }
        createdAt
        caseManager {
          username
        }
        type
      }
      accountsNeedAttention {
        id
        name
        phone
        producers {
          username
        }
      }
      ongoingTasks {
        id
        title
        status
        dueDate
        reminderDate
        priority
        assignedTo {
          id
          username
        }
        createdAt
        notes
        createdBy {
          id
          username
        }
      }
      dueInOneWeekTasks {
        id
        title
        status
        dueDate
        reminderDate
        priority
        assignedTo {
          id
          username
        }
        createdAt
        notes
        createdBy {
          id
          username
        }
      }
    }
  }
`

export const getExpiringPolicyNumber = gql`
  query getExpiringPolicyNumber($month: Int!, $year: Int!){
    getExpiringPolicyNumber(month: $month, year: $year){
      date
      numberInThisDay
      numberInAMonth
    }
  }
`

export const getExpiringPolicies = gql`
  query getExpiringPolicies($expirationEndDate: String!, $expirationStartDate: String!) {
    getExpiringPolicies(expirationEndDate: $expirationEndDate, expirationStartDate: $expirationStartDate) {
        id
        policyName
        policyNumber
        status
        carrier {
          name
        }
        premium
        effectiveDate
        expirationDate
        account {
          id
          name
        }
        carrier {
          id
          name
        }
        carrierProduct {
          id
          name
        }
        writingAgents {
          id
          username
        }
    }
  }
`
